// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-choice-lookup-existing {
  display: flex;
  flex-direction: column;
  margin-top: 10px;
}

.dl-choice-condition-existing {
  display: flex;
  flex-direction: column;
}

.dl-choice-space-between {
  display: flex;
  justify-content: space-between;
}

.form-tran-header .mat-dialog-title {
  display: flex;
  justify-content: space-between;
}

.display-none {
  display: none;
}

.justify-flex-end {
  justify-content: flex-end !important;
}

::ng-deep .form-tran-header .mat-dialog-title {
  margin: 0 0 10px;
}

::ng-deep .dl-choice-lookup-body .mat-tab-body-content {
  overflow: hidden !important;
}

.dl-choice-lookup-existing-assosiate {
  display: flex;
  flex-direction: column;
  margin-top: 10px;
}

.form-lookup-container {
  max-height: calc(50vh - 100px);
  overflow: auto;
  table-layout: fixed;
}
.form-lookup-container table {
  margin-bottom: 4px;
  border-collapse: separate;
  border-spacing: 0;
}

.cus-matchip {
  min-height: 1px !important;
  align-self: center;
  font-size: 12px;
  color: white !important;
}

.mat-spinner {
  position: fixed;
  margin-left: 50%;
  margin-right: 50%;
  top: 50%;
}

.load-spinner {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 2;
  cursor: wait;
}

.cus-span-selection {
  width: 130px;
  text-overflow: ellipsis;
  overflow: hidden;
}

.block-section {
  display: flex;
  justify-content: space-between;
}

.form-lookup-container .mat-table-sticky {
  cursor: pointer;
  opacity: 1;
}

.cdk-drop-list-dragging .cdk-drag {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}

.cdk-drag-preview {
  opacity: 0;
}

th.mat-header-cell {
  text-align: center;
}

th.mat-header-cell:first-of-type, td.mat-cell:first-of-type, td.mat-footer-cell:first-of-type {
  padding-left: 1px;
}

.mat-table tr.mat-row:hover,
.mat-table .mat-row:hover {
  cursor: pointer;
  background-color: white;
}

.form-lookup-header .mat-dialog-title {
  display: flex;
  justify-content: space-between;
}

.mat-menu-item .mat-icon {
  color: orange;
  margin-right: 8px;
}

.menu-tool {
  display: none;
  position: absolute;
  left: 55px;
  top: 24px;
  background: whitesmoke;
  border-radius: 5px;
}
.menu-tool mat-icon {
  font-size: 17px;
  height: 17px;
}
.menu-tool mat-icon:hover {
  background-color: wheat;
}

.menu-disabled {
  display: none;
}

.menu-show {
  display: block;
}

.menu-tricker {
  width: 15%;
  color: gray;
  align-self: flex-end;
  right: 27%;
  margin-bottom: -7px;
}

.trigger {
  height: 40px;
}

.td-select {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 5px;
}

.header-menu {
  display: flex;
}
.header-menu mat-select {
  align-self: center;
}
.header-menu mat-icon {
  font-size: medium;
  height: 26px;
}
.header-menu .mat-icon-button {
  width: auto;
}

.add-menus-bar {
  position: sticky;
  left: 0;
}
.add-menus-bar button {
  width: 100%;
  border-style: solid;
  border-width: 1px;
  margin-top: 3px;
  height: 30px;
}

.table-configure {
  display: flex;
  flex-direction: column;
  margin: 5px 0px 5px 0px;
  max-width: 400px;
}

.error-hint {
  font-size: 11px;
  color: white;
  background: #b71c1c;
  width: 100%;
  margin-left: 10px;
  border-radius: 4px;
}

.error-table-name {
  font-size: 11px;
  color: white;
  background: #b71c1c;
  border-radius: 4px;
}

.body-value-column {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.body-value-column .mat-form-field {
  width: 100%;
}

.dl-choice-lookup-menu {
  margin-top: -5px;
  display: flex;
  flex-direction: column;
}

.menus-items-value {
  display: flex;
  flex-direction: column;
  margin: -10px 5px 0px -20px;
  border: solid 1px ghostwhite;
  border-bottom: none;
  border-top: none;
  border-left: none;
  height: 40px;
}
.menus-items-value mat-icon {
  font-size: 14px;
}
.menus-items-value button:last-child {
  margin-top: 5px;
}

.menus-item-2 {
  margin-top: 10px;
  display: flex;
  margin-top: 2px;
}

.small-icon-button {
  width: 16px !important;
  height: 16px !important;
  line-height: 16px !important;
}
.small-icon-button .mat-icon {
  width: 13px !important;
  height: 13px !important;
  line-height: 13px !important;
}
.small-icon-button .mat-icon:hover {
  background-color: darkgray;
  border-radius: 10px;
}
.small-icon-button .material-icons {
  font-size: 14px !important;
}

#dl-choice-lookup-dragdrop-zone th {
  background: #80d9e4;
  border-left: 2.5px solid white;
  border-bottom: none;
}

#dl-choice-lookup-dragdrop-zone th:first-child {
  border-left: none;
}

:host .mat-menu-panel .mat-menu-item {
  width: 100%;
}

.mat-footer-row,
.mat-header-row,
.mat-row {
  min-width: 100%;
}

.td-select {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.menus-items-value {
  display: flex;
  flex-direction: column;
}
.menus-items-value mat-icon {
  font-size: 13px;
}

.small-icon-button {
  width: 16px !important;
  height: 16px !important;
  line-height: 1px !important;
}
.small-icon-button .mat-icon {
  width: 13px !important;
  height: 13px !important;
  line-height: 13px !important;
}
.small-icon-button .mat-icon:hover {
  background-color: darkgray;
  border-radius: 10px;
}
.small-icon-button .material-icons {
  font-size: 13px !important;
}

.header-menu:hover .menu-tool {
  display: block;
}

::ng-deep .form-lookup-container .mat-form-field-label {
  font-size: 11px !important;
  font-weight: bold;
}

::ng-deep .form-lookup-container .mat-table td.mat-cell {
  border: none;
}

::ng-deep .form-lookup-container .mat-form-field-wrapper {
  margin: 0px !important;
}

::ng-deep .form-lookup-container .mat-form-field-appearance-outline .mat-form-field-infix {
  font-size: 11px !important;
  padding: 8px 1px !important;
  margin-top: -5px;
  line-height: 1;
}

::ng-deep .form-lookup-container .mat-form-field-appearance-outline .mat-form-field-flex {
  margin-top: 1px;
}

::ng-deep .form-lookup-container th.mat-header-cell:last-of-type, td.mat-cell:last-of-type, td.mat-footer-cell:last-of-type {
  padding: 0px;
}

::ng-deep .form-lookup-container .mat-table td.mat-cell, .mat-table td.mat-footer-cell, .mat-table th.mat-header-cell {
  padding: 0 2px !important;
}

::ng-deep .dl-choice-lookup-existing .mat-form-field-label {
  font-size: 14px !important;
  font-weight: bold;
}

::ng-deep .dl-choice-lookup-existing .mat-form-field-appearance-outline .mat-form-field-infix {
  font-size: 14px !important;
  padding: 8px 0 10px 0;
  line-height: 1;
}
::ng-deep .dl-choice-lookup-existing .mat-form-field-appearance-outline .mat-form-field-infix .mat-select {
  font-size: 12px;
}

::ng-deep .dl-choice-lookup-body .mat-tab-label {
  height: 30px;
  min-width: 120px;
}

::ng-deep .dl-choice-lookup-body .mat-tab-label .mat-tab-label-content {
  font-size: 13px;
  font-weight: bold;
}

::ng-deep .dl-choice-lookup-body {
  max-width: 1137px;
}

::ng-deep .table-configure .mat-form-field-flex > .mat-form-field-infix {
  padding: 0.5em 0px !important;
}

::ng-deep .table-configure .mat-form-field-label-wrapper {
  top: -1em;
}

::ng-deep .table-configure .mat-form-field-appearance-outline.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label {
  transform: translateY(-1.5em) scale(0.75);
  width: 133.33333%;
}

@keyframes spinner {
  to {
    transform: rotate(360deg);
  }
}
.spinner:before {
  content: "";
  box-sizing: border-box;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 20px;
  height: 20px;
  margin-top: -10px;
  margin-left: -10px;
  border-radius: 50%;
  border: 2px solid #ffffff;
  border-top-color: #80d9e4;
  animation: spinner 0.8s linear infinite;
}`, "",{"version":3,"sources":["webpack://./src/app/e-form/dialog/choice-lookup/choice-lookup.component.scss"],"names":[],"mappings":"AACA;EACM,aAAA;EACA,sBAAA;EACA,gBAAA;AAAN;;AAIA;EACG,aAAA;EACA,sBAAA;AADH;;AAIA;EACG,aAAA;EACA,8BAAA;AADH;;AAKG;EACG,aAAA;EACA,8BAAA;AAFN;;AAMA;EACG,aAAA;AAHH;;AAMA;EACG,oCAAA;AAHH;;AAMA;EACG,gBAAA;AAHH;;AAMA;EACG,2BAAA;AAHH;;AAMA;EACG,aAAA;EACA,sBAAA;EACA,gBAAA;AAHH;;AAMA;EACG,8BAAA;EACA,cAAA;EACA,mBAAA;AAHH;AAIG;EACG,kBAAA;EACA,yBAAA;EACA,iBAAA;AAFN;;AAMA;EACG,0BAAA;EACA,kBAAA;EACA,eAAA;EACA,uBAAA;AAHH;;AAMA;EACG,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,QAAA;AAHH;;AAMA;EACG,eAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,UAAA;EACA,YAAA;AAHH;;AAMA;EACG,YAAA;EACA,uBAAA;EACA,gBAAA;AAHH;;AAMA;EACG,aAAA;EACA,8BAAA;AAHH;;AAMA;EACG,eAAA;EACA,UAAA;AAHH;;AAMA;EACG,sDAAA;AAHH;;AAMA;EACG,UAAA;AAHH;;AAMA;EACG,kBAAA;AAHH;;AAMA;EACI,iBAAA;AAHJ;;AAMA;;EAEG,eAAA;EACA,uBAAA;AAHH;;AAOG;EACG,aAAA;EACA,8BAAA;AAJN;;AAQA;EACG,aAAA;EACA,iBAAA;AALH;;AAQA;EACG,aAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,sBAAA;EACA,kBAAA;AALH;AAOG;EACG,eAAA;EACA,YAAA;AALN;AAQG;EACG,uBAAA;AANN;;AAUA;EACG,aAAA;AAPH;;AAUA;EACG,cAAA;AAPH;;AAUA;EACG,UAAA;EACA,WAAA;EACA,oBAAA;EACA,UAAA;EACA,mBAAA;AAPH;;AAUA;EACG,YAAA;AAPH;;AAUA;EACG,aAAA;EACC,mBAAA;EACA,uBAAA;EACA,eAAA;AAPJ;;AAUA;EACG,aAAA;AAPH;AASG;EACG,kBAAA;AAPN;AAUG;EACG,iBAAA;EACA,YAAA;AARN;AAWG;EACG,WAAA;AATN;;AAaA;EACG,gBAAA;EACA,OAAA;AAVH;AAWG;EACG,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;AATN;;AAaA;EACG,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;AAVH;;AAaA;EACG,eAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;AAVH;;AAaA;EACG,eAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;AAVH;;AAaA;EACG,aAAA;EACA,mBAAA;EACA,8BAAA;AAVH;AAWG;EACG,WAAA;AATN;;AAaA;EACG,gBAAA;EACA,aAAA;EACA,sBAAA;AAVH;;AAaA;EACG,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;AAVH;AAWG;EACG,eAAA;AATN;AAWG;EACG,eAAA;AATN;;AAaA;EACG,gBAAA;EACA,aAAA;EACA,eAAA;AAVH;;AAaA;EACG,sBAAA;EACA,uBAAA;EACA,4BAAA;AAVH;AAYG;EACG,sBAAA;EACA,uBAAA;EACA,4BAAA;AAVN;AAaG;EACE,0BAAA;EACD,mBAAA;AAXJ;AAaG;EACG,0BAAA;AAXN;;AAeA;EACG,mBAAA;EACA,8BAAA;EACA,mBAAA;AAZH;;AAeA;EACG,iBAAA;AAZH;;AAeA;EACG,WAAA;AAZH;;AAeC;;;EAGG,eAAA;AAZJ;;AAeA;EACG,aAAA;EACC,mBAAA;EACA,uBAAA;AAZJ;;AAeA;EACG,aAAA;EACA,sBAAA;AAZH;AAaG;EACG,eAAA;AAXN;;AAeA;EACG,sBAAA;EACA,uBAAA;EACA,2BAAA;AAZH;AAcG;EACG,sBAAA;EACA,uBAAA;EACA,4BAAA;AAZN;AAeG;EACE,0BAAA;EACD,mBAAA;AAbJ;AAeG;EACG,0BAAA;AAbN;;AAiBA;EACG,cAAA;AAdH;;AAiBA;EACG,0BAAA;EACA,iBAAA;AAdH;;AAiBA;EACG,YAAA;AAdH;;AAiBA;EACG,sBAAA;AAdH;;AAiBA;EACG,0BAAA;EACA,2BAAA;EACA,gBAAA;EACA,cAAA;AAdH;;AAiBA;EACG,eAAA;AAdH;;AAiBA;EACG,YAAA;AAdH;;AAiBA;EACG,yBAAA;AAdH;;AAkBA;EACG,0BAAA;EACA,iBAAA;AAfH;;AAkBA;EACG,0BAAA;EACA,qBAAA;EACA,cAAA;AAfH;AAgBG;EACG,eAAA;AAdN;;AAkBA;EACG,YAAA;EACA,gBAAA;AAfH;;AAkBC;EACE,eAAA;EACA,iBAAA;AAfH;;AAkBC;EACE,iBAAA;AAfH;;AAmBA;EAA0E,6BAAA;AAf1E;;AAgBA;EAA2D,SAAA;AAZ3D;;AAcA;EACI,yCAAA;EACA,iBAAA;AAXJ;;AAeA;EACG;IAAI,yBAAA;EAXL;AACF;AAaC;EACE,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uCAAA;AAXH","sourcesContent":["\n.dl-choice-lookup-existing {\n      display: flex;\n      flex-direction: column;\n      margin-top: 10px;\n}\n\n\n.dl-choice-condition-existing {\n   display: flex;\n   flex-direction: column;\n}\n\n.dl-choice-space-between {\n   display: flex;\n   justify-content: space-between;\n}\n\n.form-tran-header {\n   .mat-dialog-title {\n      display: flex;\n      justify-content: space-between;\n   }\n}\n\n.display-none {\n   display: none;\n}\n\n.justify-flex-end {\n   justify-content: flex-end !important;\n}\n\n::ng-deep .form-tran-header .mat-dialog-title {\n   margin: 0 0 10px;\n}\n\n::ng-deep .dl-choice-lookup-body .mat-tab-body-content {\n   overflow: hidden !important;\n}\n\n.dl-choice-lookup-existing-assosiate {\n   display: flex;\n   flex-direction: column;\n   margin-top: 10px;\n}\n\n.form-lookup-container {\n   max-height: calc(50vh - 100px);\n   overflow: auto;\n   table-layout: fixed;\n   table {\n      margin-bottom: 4px;\n      border-collapse: separate;\n      border-spacing: 0;\n   }\n}\n\n.cus-matchip {\n   min-height: 1px !important;\n   align-self: center;\n   font-size: 12px;\n   color: white !important;\n}\n\n.mat-spinner {\n   position: fixed;\n   margin-left: 50%;\n   margin-right: 50%;\n   top: 50%;\n}\n\n.load-spinner {\n   position: fixed;\n   width: 100%;\n   height: 100%;\n   top: 0;\n   left: 0;\n   right: 0;\n   bottom: 0;\n   background-color: rgba(0, 0, 0, 0.5);\n   z-index: 2;\n   cursor: wait;\n}\n\n.cus-span-selection {\n   width: 130px;\n   text-overflow: ellipsis;\n   overflow: hidden;\n}\n\n.block-section {\n   display: flex;\n   justify-content: space-between;\n}\n\n.form-lookup-container .mat-table-sticky {\n   cursor: pointer;\n   opacity: 1;\n}\n\n.cdk-drop-list-dragging .cdk-drag {\n   transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\n }\n\n.cdk-drag-preview {\n   opacity: 0;\n}\n\nth.mat-header-cell {\n   text-align: center;\n}\n\nth.mat-header-cell:first-of-type, td.mat-cell:first-of-type, td.mat-footer-cell:first-of-type {\n    padding-left: 1px;\n}\n\n.mat-table tr.mat-row:hover,\n.mat-table .mat-row:hover {\n   cursor: pointer;\n   background-color: white;\n}\n\n.form-lookup-header {\n   .mat-dialog-title {\n      display: flex;\n      justify-content: space-between;\n   }\n}\n\n.mat-menu-item .mat-icon {\n   color: orange;\n   margin-right: 8px;\n}\n\n.menu-tool {\n   display: none;\n   position: absolute;\n   left: 55px;\n   top: 24px;\n   background: whitesmoke;\n   border-radius: 5px;\n\n   mat-icon {\n      font-size: 17px;\n      height: 17px;\n   }\n\n   mat-icon:hover {\n      background-color: wheat;\n   }\n}\n\n.menu-disabled {\n   display: none;\n}\n\n.menu-show {\n   display: block;\n}\n\n.menu-tricker {\n   width: 15%;\n   color: gray;\n   align-self: flex-end;\n   right: 27%;\n   margin-bottom: -7px;\n}\n\n.trigger {\n   height: 40px;\n}\n\n.td-select {\n   display: flex;\n    flex-direction: row;\n    justify-content: center;\n    margin-top: 5px;\n}\n\n.header-menu {\n   display: flex;\n\n   mat-select {\n      align-self: center;\n   }\n\n   mat-icon {\n      font-size: medium;\n      height: 26px;\n   }\n\n   .mat-icon-button {\n      width: auto;\n   }\n}\n\n.add-menus-bar {\n   position: sticky;\n   left: 0;\n   button {\n      width: 100%;\n      border-style: solid;\n      border-width: 1px;\n      margin-top: 3px;\n      height: 30px;\n   }\n}\n\n.table-configure {\n   display: flex;\n   flex-direction: column;\n   margin: 5px 0px 5px 0px;\n   max-width: 400px;\n}\n\n.error-hint {\n   font-size: 11px;\n   color: white;\n   background: #b71c1c;\n   width: 100%;\n   margin-left: 10px;\n   border-radius: 4px;\n}\n\n.error-table-name {\n   font-size: 11px;\n   color: white;\n   background: #b71c1c;\n   border-radius: 4px;\n}\n\n.body-value-column {\n   display : flex;\n   flex-direction: row;\n   justify-content: space-between;\n   .mat-form-field {\n      width: 100%;\n   }\n}\n\n.dl-choice-lookup-menu {\n   margin-top: -5px;\n   display: flex;\n   flex-direction: column;\n}\n\n.menus-items-value {\n   display: flex;\n   flex-direction: column;\n   margin: -10px 5px 0px -20px;\n   border: solid 1px ghostwhite;\n   border-bottom: none;\n   border-top: none;\n   border-left: none;\n   height: 40px;\n   mat-icon {\n      font-size: 14px;\n   }\n   button:last-child {\n      margin-top: 5px;\n   }\n}\n\n.menus-item-2 {\n   margin-top: 10px;\n   display: flex;\n   margin-top: 2px;\n}\n\n.small-icon-button {\n   width: 16px !important;\n   height: 16px !important;\n   line-height: 16px !important;\n\n   .mat-icon {\n      width: 13px !important;\n      height: 13px !important;\n      line-height: 13px !important;\n   }\n\n   .mat-icon:hover {\n     background-color: darkgray;\n    border-radius: 10px;\n   }\n   .material-icons {\n      font-size: 14px !important;\n   }\n}\n\n#dl-choice-lookup-dragdrop-zone th {\n   background: #80d9e4;\n   border-left: 2.5px solid white;\n   border-bottom: none;\n}\n\n#dl-choice-lookup-dragdrop-zone th:first-child {\n   border-left: none;\n}\n\n:host .mat-menu-panel .mat-menu-item {\n   width: 100%;\n}\n\n .mat-footer-row,\n.mat-header-row,\n.mat-row {\n    min-width: 100%;\n}\n\n.td-select {\n   display: flex;\n    flex-direction: row;\n    justify-content: center;\n}\n\n.menus-items-value {\n   display: flex;\n   flex-direction: column;\n   mat-icon {\n      font-size: 13px;\n   }\n}\n\n.small-icon-button {\n   width: 16px !important;\n   height: 16px !important;\n   line-height: 1px !important;\n\n   .mat-icon {\n      width: 13px !important;\n      height: 13px !important;\n      line-height: 13px !important;\n   }\n\n   .mat-icon:hover {\n     background-color: darkgray;\n    border-radius: 10px;\n   }\n   .material-icons {\n      font-size: 13px !important;\n   }\n}\n\n.header-menu:hover .menu-tool {\n   display: block;\n}\n\n::ng-deep .form-lookup-container .mat-form-field-label {\n   font-size: 11px !important;\n   font-weight: bold;\n}\n\n::ng-deep .form-lookup-container .mat-table td.mat-cell {\n   border: none;\n}\n\n::ng-deep .form-lookup-container .mat-form-field-wrapper {\n   margin: 0px !important;\n}\n\n::ng-deep .form-lookup-container .mat-form-field-appearance-outline .mat-form-field-infix {\n   font-size: 11px !important;\n   padding: 8px 1px !important;\n   margin-top: -5px;\n   line-height: 1.00;\n}\n\n::ng-deep .form-lookup-container .mat-form-field-appearance-outline .mat-form-field-flex {\n   margin-top: 1px;\n}\n\n::ng-deep .form-lookup-container th.mat-header-cell:last-of-type, td.mat-cell:last-of-type, td.mat-footer-cell:last-of-type {\n   padding: 0px;\n}\n\n::ng-deep .form-lookup-container .mat-table td.mat-cell, .mat-table td.mat-footer-cell, .mat-table th.mat-header-cell {\n   padding: 0 2px !important;\n}\n\n\n::ng-deep .dl-choice-lookup-existing .mat-form-field-label {\n   font-size: 14px !important;\n   font-weight: bold;\n}\n\n::ng-deep .dl-choice-lookup-existing .mat-form-field-appearance-outline .mat-form-field-infix {\n   font-size: 14px !important;\n   padding: 8px 0 10px 0;\n   line-height: 1.00;\n   .mat-select {\n      font-size: 12px;\n   }\n}\n\n::ng-deep .dl-choice-lookup-body .mat-tab-label {\n   height: 30px;\n   min-width: 120px;\n }\n\n ::ng-deep .dl-choice-lookup-body .mat-tab-label .mat-tab-label-content {\n   font-size: 13px;\n   font-weight: bold;\n }\n\n ::ng-deep .dl-choice-lookup-body {\n   max-width: 1137px;\n }\n\n\n::ng-deep .table-configure .mat-form-field-flex > .mat-form-field-infix { padding: 0.5em 0px !important;}\n::ng-deep .table-configure .mat-form-field-label-wrapper { top: -1em; }\n\n::ng-deep .table-configure .mat-form-field-appearance-outline.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label {\n    transform: translateY(-1.5em) scale(.75);\n    width: 133.33333%;\n}\n\n\n@keyframes spinner {\n   to {transform: rotate(360deg);}\n }\n\n .spinner:before {\n   content: '';\n   box-sizing: border-box;\n   position: absolute;\n   top: 50%;\n   left: 50%;\n   width: 20px;\n   height: 20px;\n   margin-top: -10px;\n   margin-left: -10px;\n   border-radius: 50%;\n   border: 2px solid #ffffff;\n   border-top-color: #80d9e4;\n   animation: spinner .8s linear infinite;\n }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
